import { AppContextProvider } from "./shared/contexts/app-context/components/AppContext";
import {
    PortfolioContextProvider
} from "./shared/contexts/portfolio-context/components/PortfolioContextProvider";
import { Stack } from "@mui/material";
import { ApplicationHeader } from "./screens/application-header/ApplicationHeader";
import { ModuleSelector } from "./screens/module-selector/components/module-selector/ModuleSelector";
import {
    ApplicationWorkspace
} from "./screens/application-workspace/components/application-workspace/ApplicationWorkspace";

export function ApplicationPage() {
    return (
        <AppContextProvider>
            <PortfolioContextProvider>
                <Stack
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '99.9vh'
                    }}
                >
                    <ApplicationHeader/>
                    <ModuleSelector />
                    <ApplicationWorkspace />
                </Stack>
            </PortfolioContextProvider>
        </AppContextProvider>
    );
}
